
import VueSlickCarousel from 'vue-slick-carousel';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
// optional style for arrows & dots
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css';

export default {
    name: "QdapHomeGuideSection",
    
    components: { VueSlickCarousel },

    props: {
    
        data: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            pageData: null,
            
            settings: {
                "dots": true,
                "focusOnSelect": false,
                "infinite": true,
                "speed": 500,
                "slidesToShow": 3,
                "slidesToScroll": 3,
                "touchThreshold": 5,
                "responsive": [
                {
                    "breakpoint": 1024,
                    "settings": {
                    "slidesToShow": 2,
                    "slidesToScroll": 2,
                    "infinite": true,
                    "dots": true,
                    "arrows": true
                    }
                },
                {
                    "breakpoint": 768,
                    "settings": {
                    "slidesToShow": 1,
                    "slidesToScroll": 1,
                    "arrows": true
                    }
                },
                {
                    "breakpoint": 480,
                    "settings": {
                    "slidesToShow": 1,
                    "slidesToScroll": 1,
                    "arrows": true
                    }
                }
                ]
            }
        }
    },
    mounted() {
    },
    methods: {
    },
}
